export interface OptimisticCacheSnapshot<T> {
  previous: T;
  optimistic: T;
}

/**
 * Restore an optimistic cache write only while that exact write is still the
 * current value. A refetch or another mutation owns any newer snapshot.
 */
export function rollbackOptimisticCacheSnapshot<T>(
  current: T | undefined,
  snapshot: OptimisticCacheSnapshot<T> | undefined
): T | undefined {
  return snapshot && current === snapshot.optimistic
    ? snapshot.previous
    : current;
}
